import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import Modal from "../components/modal.react";
import InputCustom from "../components/inputCustom.react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";

export default class RemoveSection extends Component {
  removeSection = () => {
    const {
      actions,
      sectionUID,
      notificationSystem,
      objectUID,
      afterEditSuccessAction
    } = this.props;
    actions.removeSection(sectionUID).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        afterEditSuccessAction(objectUID);
      }
    });
    actions.setIsRemoveSectionModalVisible(false);
  };

  openRemoveSectionModal = () => {
    const { actions, sectionUID } = this.props;
    actions.setIsRemoveSectionModalVisible(sectionUID);
  };

  closeRemoveSectionModal = () => {
    const { actions, sectionUID } = this.props;
    actions.setIsRemoveSectionModalVisible(false);
  };

  render() {
    const { isRemoveModalVisible, sectionUID } = this.props;

    return (
      <div className="col-xs-12">
        <button className="error" onClick={this.openRemoveSectionModal}>
          Usuń sekcję
        </button>
        {isRemoveModalVisible === sectionUID && (
          <Modal
            closeModalAction={this.closeRemoveSectionModal}
            enterAction={this.removeSection}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs middle-xs">
              <h3 className="col-xs-12">Potwierdź usunięcie</h3>
              <p>Czy napewno usunąć?</p>
              <div className="col-xs-12">
                <button className="error" onClick={this.removeSection}>
                  Tak
                </button>
                <button className="info" onClick={this.closeRemoveSectionModal}>
                  Nie
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/template/removeSection.react.js